import React, { useState } from "react";
import T from "prop-types";
import { renderIf } from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";
import { REPAIR_EVALUATION_REJECTED } from "MODULES/inventories/constants";
import { connect } from "react-redux";
import { removeMainComponent } from "MODULES/RepairOrders/actions";
import { TEARDOWN } from "../../../../../constants";
import ConfirmAction from "../../../../../../shared/components/ConfirmAction";

function RemoveMainComponent({ confirm }) {
  const [removalVisibility, setRemovalVisibility] = useState(false);
  return (
    <DropDownItem onClick={() => setRemovalVisibility(true)}>
      <Icon name="ban" fixed />
      &nbsp;Main Component Consumed - Remove From Stock
      <ConfirmAction
        onConfirm={confirm}
        close={() => setRemovalVisibility(false)}
        open={removalVisibility}
        btnClass="btn-danger"
        btnText={`Yes, Remove Main Component`}
        cancelText="Cancel"
        icon={<i className={`fa fa-fw fa-ban`} />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to remove this component?
      </ConfirmAction>
    </DropDownItem>
  );
}

export const canRemoveMainComponent = ({ lineItem }) =>
  lineItem.action_requested === TEARDOWN &&
  !lineItem.received &&
  lineItem.approval_status === REPAIR_EVALUATION_REJECTED;

export default renderIf(canRemoveMainComponent)(
  connect(undefined, (dispatch, ownProps) => ({
    confirm: () => dispatch(removeMainComponent(ownProps.lineItem.id))
  }))(RemoveMainComponent)
);

RemoveMainComponent.propTypes = {
  confirm: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RemoveMainComponent/RemoveMainComponent.jsx